import { FAQInfoSection } from './FAQInfoSection';

class FAQInfoMainSection {
  constructor(params) {
    this.title = params.title;
    this.sections = (params.sections || []).map(section => new FAQInfoSection(section));
  }
}

export { FAQInfoMainSection };



// WEBPACK FOOTER //
// ./src/models/FAQInfoMainSection.js